import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import makedefault from "src/Assets/images/makedefault.png";
import useStyles from "./styles";
import API from "../../../network";
import "./index.css";
import { IconButton } from "@material-ui/core";
import { IoIosClose } from "react-icons/io";

const CommunitiesList = ({
  data,
  handleMakeDefault,
  handleListItem,
  selectedItem,
  country,
  handleMouseOver,
  handleMouseOut,
  handleViewActivity,
  handleMakeDefaultAfterSignIn,
  handleMakeFollowUnfollow,
  signIn,
  locationIconClickedCommunityId,
  hasCountryCommunity,
  loading,
  openStartCommunity,
  searchValue,
  isPrivatePopupClosed,
  defaultCountry,
  countryHasDefaultCommBlocked,
  showAlertBox,
  setShowAlertBox,
  openStartCommunityPopup,
  isGlobalSearch,
}) => {
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
  const { buttonContainer, defaultButton, defaultImageButton } = useStyles();
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const [list, setList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [followReqMessage, setFollowReqMessage] = useState("");

  const location = useLocation();

  useEffect(() => {
    /**
     * followStatus
     * 1: user following the community
     * 2: default community of the use
     * 5 & 6: user is blocked in the community
     */
    let filteredData = [];

    if (signIn) {
      filteredData = data?.filter(
        (item) => item?.followStatus !== 1 && item?.followStatus !== 2,
      );
    } else {
      filteredData = data;
    }

    // Move selected item to the top if it's selected
    if (locationIconClickedCommunityId) {
      const sortedList = [
        ...filteredData.filter(
          (item) => item.tenantId === locationIconClickedCommunityId,
        ),
        ...filteredData.filter(
          (item) => item.tenantId !== locationIconClickedCommunityId,
        ),
      ];
      setList(sortedList);
    } else {
      setList(filteredData);
    }
  }, [data, signIn, locationIconClickedCommunityId]); // Dependencies include signIn and locationIconClickedCommunityId

  // const requestToFollow = (id) => {
  //   let formdata = new FormData();
  //   formdata.append("tenantId", id);
  //   API.requestToFollow(formdata)
  //   .then((res) => {
  //     alert(res.data.status);
  //   })
  // }

  const handleClose = () => {
    setOpen(false);
  };

  const requestToFollow = (id) => {
    const formData = new FormData();
    formData.append("tenantId", id);

    API.requestToFollow(formData)
      .then((res) => {
        if (res?.data?.status) {
          setFollowReqMessage(
            `${res.data.status}. You will be notified once the moderator has approved your request.`,
          );
          setOpen(true);
        } else {
          setFollowReqMessage("Unexpected response from server.");
          setOpen(true);
        }
      })
      .catch((err) => {
        console.error("Error in requestToFollow:", err);
        setFollowReqMessage("Failed to send follow request. Please try again.");
        setOpen(true);
      });
  };

  const onSendUnblockRequest = async (id, commName) => {
    try {
      const { displayName = "" } = userDetails?.userData || {};
      const unblockReqMsg = `Dear Moderator,%0A%0AI request you to unblock my access to ${commName} community.%0A%0AThank you,%0A${displayName}`;
      const formData = new FormData();
      formData.append("tenantId", id);
      formData.append("reqMsg", unblockReqMsg);
      const response = await API.sendUnblockRequest(formData);
      if (response?.data?.status === "Request sent successfully") {
        setFollowReqMessage(
          `Your request to unblock has been sent successfully to the moderator. You will be notified once your access is restored.`,
        );
        setOpen(true);
      }
    } catch (error) {
      console.error("Error in junblock request:", error);
      alert("Failed to send unblock request. Please try again.");
      setOpen(true);
    }
  };

  const isCommunityPrivate = (communityType) => {
    const commType = communityType ?? "";
    return String(commType).toLowerCase() === "private";
  };

  console.log(`list of communies,,:`, list);

  return (
    <>
      {list?.length > 0 ? (
        list?.map((item, index) => {
          return (
            <div
              onClick={() => handleListItem(item?.tenantId, item?.location)}
              key={`key-${item?.tenantId}-${item?.communityName}`}
              onMouseOver={() =>
                handleMouseOver(item?.tenantId, item?.location)
              }
              onMouseOut={handleMouseOut}
            >
              <Grid
                container
                className={`default-community-list-card-container ${
                  selectedItem === item?.tenantId ? "selected-community" : ""
                }`}
                key={index}
                style={{
                  height: isCommunityPrivate(item?.communityType)
                    ? "16.5vh"
                    : "14vh",
                }}
              >
                <Grid item xs={3}>
                  {/* src={item?.imageUrl} */}
                  <img
                    src={
                      item?.imageUrl
                        ? `${imageServerURL}${item.imageUrl}`
                        : process.env.REACT_APP_DUMMY_COMMUNITY_IMAGE
                    }
                    className="default-community-list-card-image"
                    alt="defaultCommunityImage"
                  />
                </Grid>
                <Grid
                  item
                  xs={9}
                  className="default-community-list-card-button-container"
                >
                  <div>
                    {isCommunityPrivate(item?.communityType) && (
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#4795de",
                          textTransform: "capitalize",
                        }}
                      >
                        {item?.communityType} Community
                      </div>
                    )}
                    <Tooltip title={item?.communityName}>
                      <div className="community-name-default-list">
                        {item?.communityName}
                      </div>
                    </Tooltip>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#707070",
                        height: "20px",
                        overflow: "auto",
                        marginBottom: "3px",
                        scrollbarWidth: "none",
                      }}
                    >
                      {item?.description}
                    </div>
                  </div>
                  {location?.pathname !== "/communities" ? (
                    <div className={buttonContainer}>
                      <div className={defaultButton}>
                        <button
                          className="make-default-button-follow-more-community"
                          variant="contained"
                          onClick={() =>
                            handleMakeDefault(
                              item?.communityName,
                              item?.tenantId,
                              country,
                            )
                          }
                          size="small"
                        >
                          <div>
                            <img
                              src={makedefault}
                              className="make-default-image-follow-more-community"
                              alt="default-icon"
                            />
                            Make Default
                          </div>
                        </button>
                      </div>
                      <div className={defaultButton}>
                        <button
                          className="view-activity-button-follow-more-community"
                          variant="contained"
                          onClick={() =>
                            handleViewActivity(
                              item?.communityName,
                              item?.tenantId,
                              country,
                              item?.communityType,
                              "ViewActivityBeforeSignIn",
                              defaultCountry,
                            )
                          }
                          size="small"
                        >
                          View Activity
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className={buttonContainer}>
                      {item?.followStatus === 2 && (
                        <div className={defaultButton}>
                          <Button variant="contained" onClick={() => {}}>
                            This is your Default Community
                          </Button>
                        </div>
                      )}
                      {item?.followStatus === 0 &&
                        (item?.communityType === "Public" ||
                          item?.communityType === "public") && (
                          <div className={defaultButton}>
                            <button
                              className="follow-button-follow-more-community"
                              variant="contained"
                              onClick={() =>
                                handleMakeFollowUnfollow(
                                  item?.tenantId,
                                  item?.communityName,
                                  item?.followStatus,
                                )
                              }
                            >
                              <span>Follow</span>
                            </button>
                          </div>
                        )}
                      {item?.followStatus === 0 &&
                        (item?.communityType === "private" ||
                          item?.communityType === "Private") && (
                          <div className={defaultButton}>
                            <button
                              className="follow-button-follow-more-private-community"
                              variant="contained"
                              onClick={(event) => {
                                event.stopPropagation();
                                requestToFollow(item?.tenantId);
                              }}
                            >
                              <span>Request to Follow</span>
                            </button>
                          </div>
                        )}
                      {(item?.followStatus === 5 ||
                        item?.followStatus === 6) && (
                        <div className={defaultButton}>
                          <button
                            className="unblock-button-follow-more-community"
                            variant="contained"
                            onClick={(event) => {
                              event.stopPropagation();
                              onSendUnblockRequest(
                                item?.tenantId,
                                item?.communityName,
                              );
                            }}
                          >
                            <span>Request to Unblock</span>
                          </button>
                        </div>
                      )}
                      {item?.followStatus === 1 && (
                        <div className={defaultButton}>
                          <Button
                            style={{ height: "30px" }}
                            variant="contained"
                            onClick={() =>
                              handleMakeFollowUnfollow(
                                item?.tenantId,
                                item?.communityName,
                                item?.followStatus,
                              )
                            }
                          >
                            <span style={{ fontSize: "10px" }}>Unfollow</span>
                          </Button>
                        </div>
                      )}
                      {item?.followStatus !== 2 &&
                        item?.followStatus !== 5 &&
                        item?.followStatus !== 6 && (
                          <div className={defaultButton}>
                            <button
                              // className="follow-button-follow-more-community"
                              className={
                                item?.communityType?.toLowerCase() === "private"
                                  ? "follow-button-follow-more-private-community"
                                  : "follow-button-follow-more-community"
                              }
                              variant="contained"
                              onClick={() =>
                                handleViewActivity(
                                  item?.communityName,
                                  item?.tenantId,
                                  country,
                                  item?.communityType,
                                  "ViewActivityAfterSignIn",
                                  defaultCountry,
                                )
                              }
                            >
                              <span>View Activity</span>
                            </button>
                          </div>
                        )}
                      {item?.followStatus !== 2 &&
                        item?.followStatus !== 5 &&
                        item?.followStatus !== 6 &&
                        (item?.communityType === "Public" ||
                          item?.communityType === "public") && (
                          <div className={defaultImageButton}>
                            <Tooltip title="Make as Default Community" arrow>
                              <button
                                className="make-default-img-btn"
                                variant="contained"
                                onClick={() =>
                                  handleMakeDefaultAfterSignIn(item?.tenantId)
                                }
                              >
                                <img
                                  src={makedefault}
                                  alt="make default"
                                  width={"12px"}
                                  height={"12px"}
                                />
                              </button>
                            </Tooltip>
                          </div>
                        )}
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          );
        })
      ) : (
        <div>
          {!loading && !openStartCommunity && isPrivatePopupClosed ? (
            !isGlobalSearch &&
            hasCountryCommunity &&
            searchValue === "" &&
            !countryHasDefaultCommBlocked ? (
              <div>
                {showAlertBox ? (
                  <CommunityAlert
                    onClose={() => setShowAlertBox(false)}
                    openStartCommunityPopup={openStartCommunityPopup}
                    message={`
                    You are already following all communities in ${country}.
                    There are no new communities to follow. Click Ok to start a new community.`}
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              <p style={{ margin: "auto" }}>
                {isGlobalSearch && searchValue === ""
                  ? ""
                  : countryHasDefaultCommBlocked && searchValue === ""
                    ? `Your default community in ${country} has been blocked by the moderator. There are no other communities available in ${country}. To continue signing in, please select another country and choose a new default community.`
                    : "No community Data Found"}
              </p>
            )
          ) : null}
        </div>
      )}
      <Dialog onClose={handleClose} open={open}>
        <DialogContent>
          <p>{followReqMessage}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CommunitiesList;

function CommunityAlert({ openStartCommunityPopup, onClose, message }) {
  return (
    <div
      style={{
        border: "1px solid #373334",
        fontSize: "16px",
        padding: "12px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "white",
        color: "#707070",
      }}
    >
      <IconButton
        onClick={onClose}
        style={{
          marginLeft: "auto",
          padding: "2px",
          marginTop: "-8px",
          marginRight: "-6px",
          outline: "none !important",
        }}
      >
        <IoIosClose />
      </IconButton>
      {message}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "18px",
        }}
      >
        <button
          style={{
            backgroundColor: "#3B82F6",
            color: "white",
            fontSize: "14px",
            border: "none",
            width: "80px",
            padding: "4px",
            borderRadius: "6px",
          }}
          onClick={openStartCommunityPopup}
        >
          Ok
        </button>
      </div>
    </div>
  );
}
